import React from "react";
import {
    Stack,
    ScrollablePane,
    ActivityItem,
    Theme,
    Icon,
    Text,
    Grid,
    GridRow,
    GridColumn,
    useDateRender,
    getUsernameWithoutPrefix
} from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../core/security/AuthorizationWrapper";
import { NoteItem } from "../hooks/state/NoteItem";
import { useNotesState } from "../hooks/state/useNotesState";
import { useNotesActions } from "../hooks/useNotesActions";
import { NoteDelete } from "./NoteDelete";

export const NotesList: React.FC = () => {
    const { notes, subjectId, isDeleteSupported, accessRights, style, renderBadge } = useNotesState();
    const { checkIfNoteBelongsToUser, checkIfNoteBelongsToSubject } = useNotesActions();
    const { renderDateTime } = useDateRender();

    const checkIsDeletable = (note: NoteItem) =>
        isDeleteSupported && checkIfNoteBelongsToUser(note) && checkIfNoteBelongsToSubject(note, subjectId);

    const listHeight = style?.height ? 0.5 * Number(style.height) : 200;

    return (
        <Stack style={{ height: listHeight }}>
            <ScrollablePane>
                <Grid>
                    {notes.map((note: NoteItem, index: number) => (
                        <GridRow key={index} style={{ margin: 0, display: "flex" }}>
                            <GridColumn style={{ width: "100%" }}>
                                <ActivityItem
                                    key={index}
                                    styles={{
                                        root: { marginBottom: 10, width: "100%" },
                                        activityContent: { width: "100%" }
                                    }}
                                    activityIcon={<Icon iconName="QuickNote" />}
                                    comments={[
                                        <Text
                                            key={1}
                                            testId={`note-content-${index}`}
                                            nowrap={false}
                                            styles={{ root: { wordBreak: "break-all", width: "auto" } }}
                                        >
                                            {note.content}
                                        </Text>
                                    ]}
                                    activityDescription={
                                        <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 6 }}>
                                            <Text
                                                styles={{
                                                    root: {
                                                        fontWeight: "bold",
                                                        color: Theme.palette.themeDarkAlt
                                                    }
                                                }}
                                            >
                                                {getUsernameWithoutPrefix(note.author)}
                                            </Text>

                                            <Text>added note</Text>

                                            {renderBadge && renderBadge(note)}
                                        </Stack>
                                    }
                                    timeStamp={renderDateTime(new Date(note.creationDate))}
                                />
                            </GridColumn>
                            {checkIsDeletable(note) && (
                                <AuthorizationWrapper accessRights={accessRights}>
                                    <GridColumn style={{ width: "auto" }}>
                                        <NoteDelete id={note.id} />
                                    </GridColumn>
                                </AuthorizationWrapper>
                            )}
                        </GridRow>
                    ))}
                </Grid>
            </ScrollablePane>
        </Stack>
    );
};
